import PropTypes from 'prop-types';
import { useMemo } from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

import { availableServices } from './helpers/socialMediaServices';
import SocialMediaButton from './SocialMediaButton';

const SocialMediaButtons = ({
  url,
  title,
  vertical = false,
  selected = null,
  showInvisible = false,
  disabled = false,
  ...rest
}) => {
  const socialButtonsToRender = availableServices.reduce(
    (accumulator, social) => {
      // If selected socials networks exist
      if (selected && selected.length) {
        // If the social network exists we keep it
        if (selected.includes(social.name)) {
          accumulator.push({ ...social, inactive: false });

          return accumulator;
        }

        // Otherwise and only if the showInvisible's var exists we inactive it
        if (showInvisible) {
          accumulator.push({ ...social, inactive: true });

          return accumulator;
        }

        return accumulator;
      }

      if (selected && selected.length === 0 && showInvisible) {
        accumulator.push({ ...social, inactive: true });
      } else {
        accumulator.push(social);
      }

      return accumulator;
    },
    [],
  );

  const renderButtons = useMemo(
    () =>
      socialButtonsToRender.map((social) => (
        <ButtonLi pr={3} py={1} key={social.name} vertical={vertical}>
          <SocialMediaButton
            {...social}
            {...rest}
            url={encodeURI(`${social.url + url}&text=${title}`)}
            shareUrl={url}
            title={title}
            social={social.name}
            label={social.label}
            vertical={vertical}
            disabled={disabled || Boolean(social?.disabled)}
          />
        </ButtonLi>
      )),
    [socialButtonsToRender, title, url, vertical],
  );

  return (
    <ButtonUl data-testid="share-buttons" vertical={vertical}>
      {renderButtons}
    </ButtonUl>
  );
};

SocialMediaButtons.propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.arrayOf(PropTypes.string),
  showInvisible: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  vertical: PropTypes.bool,
};

export default SocialMediaButtons;

const ButtonLi = styled.li.attrs((attrs) => ({
  pl: attrs.vertical ? 3 : 0,
}))`
  display: flex;
  flex-direction: ${(props) => (props?.vertical ? 'row' : 'column')};
  ${space}
`;

const ButtonUl = styled.ul`
  display: flex;
  flex-direction: ${(props) => (props?.vertical ? 'column' : 'row')};
`;
